export default "__VITE_ASSET__DN0nGaPk__"